"use client";

import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom'

const DualCTASection = () => {
  const { t } = useTranslation("home");
  const navigate = useNavigate()

  const options = [
    {
      role: "candidate",
      bgClass: "bg-blue-600",
      // 1. On ne garde que le chemin de l'image (sans le url('...'))
      img: "/pictures/pages/home/Candidate.webp",
      url: process.env.REACT_APP_URL
    },
    {
      role: "employer",
      bgClass: "bg-gray-900",
      // 1. Pareil ici
      img: "/pictures/pages/home/Employer.webp",
      url: process.env.REACT_APP_PRO_URL
    }
  ];

  return (
    <section className="py-24 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            {t('cta.title')} <span className="text-yellow-500">{t('cta.titleHighlight')}</span>
          </h2>
          <p className="text-gray-500">{t('cta.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {options.map((opt, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, x: idx === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
              className="relative h-80 rounded-3xl overflow-hidden group cursor-pointer"
              onClick={() => window.location.href = opt.url + '/register'}
            >
              {/* 2. Remplacement du background CSS par une balise img native */}
              <img
                src={opt.img}
                alt={t(`cta.${opt.role}.title`)} // Excellent pour l'accessibilité et le SEO
                loading="eager" // 3. Indique qu'il ne faut pas attendre (pas de lazy loading)
                fetchpriority="high" // 3. Dit au navigateur que c'est l'élément le plus important (LCP)
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
              />

              {/* Le voile dégradé noir par-dessus l'image reste intact */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />

              {/* Content */}
              <div className="absolute inset-0 p-8 flex flex-col justify-end">
                <span className="inline-block px-3 py-1 mb-4 text-xs font-bold text-white bg-white/20 backdrop-blur-md rounded-full w-fit">
                  {t(`cta.${opt.role}.badge`)}
                </span>
                <h3 className="text-3xl font-bold text-white mb-2">{t(`cta.${opt.role}.title`)}</h3>
                <p className="text-gray-200 mb-6 max-w-sm">{t(`cta.${opt.role}.desc`)}</p>

                <button className="flex items-center gap-2 text-white font-bold group-hover:gap-4 transition-all" type="button">
                  {t(`cta.${opt.role}.btn`)} <ArrowRight />
                </button>
              </div>
            </motion.div>

          ))}
        </div>
      </div>
    </section>
  );
};

export default DualCTASection;